<template>
  <label class="flex items-start gap-2 text-sm cursor-pointer hover:bg-gray-50 p-2 rounded text-gray-600 font-normal">
    <input
      type="checkbox"
      class="checkbox checkbox-xs checkbox-primary mt-0.5"
      v-model="model"
      :value="value"
    />
    <slot />
  </label>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: { type: [Array, String, Boolean] },
  value: { type: [String, Boolean] },
});

const emit = defineEmits(['update:modelValue']);

const model = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>
